<template>
    <div></div>
</template>

<script>
    import SwitchProviderAction from "@/action/actions/SwitchProviderAction"
    import { workflowService } from "@/service"

    export default {
        async created() {
            const providerKey = this.$route.params.providerKey
            const applyMode = this.$route.params.mode
            const action = new SwitchProviderAction(providerKey, applyMode)
            await workflowService.invoke(action)
            await this.$router.replace(workflowService.getProviderStartRoute(providerKey, applyMode))
        },
    }
</script>
